import "./Marquee.css";

/* ---------------------------------------------------------------------------
   Marquee — a strip that never stops.

   The children are rendered twice so the track can translate a clean -50%
   and loop without a seam. The duplicate is hidden from assistive tech; the
   first copy carries the real content.

   `speed` picks one of the shared durations, `reverse` sends it the other
   way — alternating direction on stacked strips is what stops a wall of
   photographs looking like one sliding block.
--------------------------------------------------------------------------- */

const Marquee = ({ children, speed = "mid", reverse = false, className = "" }) => (
  <div className={`runner marquee ${className}`}>
    <div
      className={`runner-track ${reverse ? "runner-track--reverse" : ""}`}
      style={{ animationDuration: `var(--run-${speed})` }}
    >
      <div className="marquee-set">{children}</div>
      <div className="marquee-set" aria-hidden="true">
        {children}
      </div>
    </div>
  </div>
);

export default Marquee;
